<h2 mat-dialog-title>Extender el servicio del deportista</h2>
<mat-dialog-content>
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <input type="hidden" formControlName="usuarioId" value="" />
<br>

    <mat-form-field appearance="outline" 
    class="example-full-width"
    style="padding-left: 10px; font-size: smaller">
      <mat-label>Nueva fecha limite de servicio *</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="fechaNueva" placeholder="Fecha limite del ingreso del deportista">

      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Comentario</mat-label>
      <input
        formControlName="comentario"
        matInput
        placeholder="Comentario o número de factura"
        value=""
      />
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>
